import React from 'react';
import styles from './PreviewFrame.module.scss';

type Props = {
  device: string;
};

const PreviewFrame: React.FC<Props> = ({ device, children }) =>
  device === 'sp' ? (
    <div className={styles.spFrame}>
      <div className={styles.spFrame__inner}>{children}</div>
    </div>
  ) : (
    <>{children}</>
  );

export default PreviewFrame;
